export default __webpack_public_path__ + "static/media/real_estate.14f7c30e.JPG";